var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShape8 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 97,
  height: 45,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#shape-8_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F3F4",
  d: "m48.9 7-11 14.7L24.2 0 0 44.1h96.3L68.8 7z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "shape-8_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h96.3v44.1H0z"
})))));
export { SvgShape8 as ReactComponent };
export default __webpack_public_path__ + "static/media/shape-8.24d7ef3ea21c2277f9f0.svg";